import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getUsersAPI() {
  const url = `${AWS_API_URL}/admin/users`;
  return getRequest(url, await authorize());
}
